export enum BroadcastMessage {
  ClearActiveAnnouncementsCache = 'event:clear:active:announcements:cache',
  ClearDefaultTeasersCache = 'event:clear:default:teasers:cache',
  ClearDisclaimerAcceptedCache = 'event:clear:disclaimer:accepted:cache',
  ClearPlayerCache = 'event:clear:player:cache',
  ClearResultsCache = 'event:clear:results:cache',
  ClearScratchcardOrdersCache = 'event:clear:scratchcard:orders:cache',
  ClearSingleOrdersCache = 'event:clear:single:orders:cache',
  ClearSubscriptionOrdersCache = 'event:clear:subscription:orders:cache',
  ClearTeasersCache = 'event:clear:teasers:cache',
  ClearTransactionsCache = 'event:clear:transactions:cache',
  ContextChange = 'event:context:change',
  EmailVerificationFinished = 'event:email:verification:finished',
}

class Broadcaster {
  private channel: Maybe<BroadcastChannel> = null
  private listeners: Map<BroadcastMessage, Set<() => void>> = new Map()

  constructor() {
    try {
      this.channel = new BroadcastChannel('ltc-channel')
      this.channel.onmessage = ({ data }) => {
        this.notifyListeners(data)
      }
    } catch {
      this.close()
    }
  }

  close() {
    this.channel?.close()
    this.channel = null
    this.listeners.clear()
  }

  off(eventName: BroadcastMessage, listener: () => void) {
    this.listeners.get(eventName)?.delete(listener)
  }

  on(eventName: BroadcastMessage, listener: () => void) {
    if (import.meta.server) return this

    if (!this.listeners.has(eventName)) {
      this.listeners.set(eventName, new Set())
    }
    this.listeners.get(eventName)?.add(listener)

    return () => this.off(eventName, listener)
  }

  postMessage(message: BroadcastMessage) {
    this.channel?.postMessage(message)
  }

  private notifyListeners(eventName: BroadcastMessage) {
    this.listeners.get(eventName)?.forEach((listener) => listener())
  }
}

const broadcasterInstance = new Broadcaster()
export default broadcasterInstance
